import { render, staticRenderFns } from "./PublicPage.vue?vue&type=template&id=be4878d0&"
import script from "./PublicPage.vue?vue&type=script&lang=js&"
export * from "./PublicPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports